import { Typography } from '@mui/material'
import React from 'react'

export type TextProps = {
  children?: React.ReactNode,
  style?: object
  center?: boolean,
  description?: boolean,
  compact?: boolean,
  fontSize?: number,
  updates?: boolean
}

export const Text = ({ children, center, description, compact, fontSize, updates }: TextProps): React.ReactElement => {
  return (
    <Typography
      sx={[
        fontSize && { fontSize: fontSize },
        compact && { lineHeight: 0.8 },
        center && { textAlign: "center" },
        description && { color: "#808080" },
        updates && { color: "#7EB48A" }
      ]}
      variant="body1"
    >
      {children}
    </Typography>
  );
}

export const KpiText = ({ children, center, description }: TextProps): React.ReactElement => {
  return (
    <Typography
      sx={[
        center && { textAlign: "center" },
        { textTransform: "uppercase" },
        description && { color: "#808080", fontWeight: 600 },
      ]}
      variant="body1"
    >
      {children}
    </Typography>
  );
}

export default Text